export default {
  sections: {
    payment: 'Pagamento',
  },
  labels: {
    proceed_to_payment: 'Prossiga para o pagamento via link ou leia o código QR',
  },
  buttons: {
    generate_new_link: 'Gerar novo link',
    copy_link: 'Copiar link',
    pay_now: 'Pagar agora',
  },
  toasts: {
    failed_to_create_payment_link: 'Falha ao carregar o link de pagamento',
  },
};
